import * as Block from "bs-platform/lib/es6/block.js";
import * as Curry from "bs-platform/lib/es6/curry.js";
import * as Bolt0_list$Bolt0 from "bolt0/./bolt0_list.bs.js";
import * as Fasta$SolvuuRoot0 from "./fasta.bs.js";
import * as Fmt_bs$SolvuuRoot0 from "./fmt_bs.bs.js";
import * as Import$SolvuuRoot0 from "./import.bs.js";
import * as Fmt_atd$SolvuuRoot0 from "./fmt_atd.bs.js";
import * as Fmt_type_bs$SolvuuRoot0 from "./fmt_type_bs.bs.js";
import * as Fmt_type_atd$SolvuuRoot0 from "./fmt_type_atd.bs.js";

function to_string_hum(param) {
  if (param >= 3654863) {
    if (param >= 487611253) {
      if (param >= 748691835) {
        if (param >= 793449722) {
          if (param >= 826371656) {
            if (param >= 962246961) {
              return "ASCII";
            } else {
              return "JSON";
            }
          } else if (param >= 804241803) {
            return "HTML";
          } else {
            return "Gzip";
          }
        } else if (param >= 758940238) {
          return "Date";
        } else {
          return "Cram";
        }
      } else if (param !== 642196241) {
        if (param >= 737157829) {
          if (param >= 737456202) {
            return "Boolean";
          } else {
            return "Biom";
          }
        } else if (param >= 736760884) {
          return "Bash";
        } else {
          return "BigWig";
        }
      } else {
        return "Newick";
      }
    } else if (param >= 107576104) {
      if (param >= 243398197) {
        if (param >= 374637448) {
          if (param >= 486566049) {
            return "BigBed";
          } else {
            return "Maybe";
          }
        } else if (param >= 365180284) {
          return "Float";
        } else {
          return "Fastq";
        }
      } else if (param >= 243398181) {
        return "Fasta";
      } else {
        return "Solvuu_runtime (json)";
      }
    } else if (param !== 4002953) {
      if (param >= 4149247) {
        if (param >= 4298873) {
          return "Vcf";
        } else {
          return "Sam";
        }
      } else if (param >= 4055352) {
        return "Qza";
      } else {
        return "Integer";
      }
    } else {
      return "PNG";
    }
  } else if (param >= -293895564) {
    if (param >= -4561036) {
      if (param >= 3304737) {
        if (param >= 3553607) {
          if (param >= 3556729) {
            return "Gtf";
          } else {
            return "Gff";
          }
        } else if (param >= 3357606) {
          return "CSV";
        } else {
          return "Bed";
        }
      } else if (param >= 3303854) {
        return "Bam";
      } else {
        return "Solvuu_fmt";
      }
    } else if (param !== -113318020) {
      if (param >= -56835286) {
        if (param >= -50740607) {
          return "Bam (index)";
        } else {
          return "Solvuu (dataframe)";
        }
      } else if (param >= -77614959) {
        return "Solvuu (bigdata)";
      } else {
        return "Solvuu_type (json)";
      }
    } else {
      return "Rdata";
    }
  } else if (param >= -953902196) {
    if (param >= -792364981) {
      if (param >= -574959090) {
        if (param >= -522825178) {
          return "Solvuu";
        } else {
          return "Cram (index)";
        }
      } else if (param >= -619744749) {
        return "Solvuu_fmt (json)";
      } else {
        return "Bytes";
      }
    } else if (param >= -861261133) {
      return "Solvuu_type";
    } else {
      return "Vcf (index)";
    }
  } else if (param !== -1015245230) {
    if (param >= -973518485) {
      if (param >= -972455391) {
        return "Solvuu (json)";
      } else {
        return "MultiQC";
      }
    } else if (param >= -976970511) {
      return "String";
    } else {
      return "Fasta (index)";
    }
  } else {
    return "Solvuu_eval (json)";
  }
}

function type_of(_x) {
  while (true) {
    var x = _x;

    if (typeof x === "number") {
      return x;
    } else {
      var variant = x[0];

      if (variant >= 243398181) {
        if (variant >= 374637448) {
          if (variant !== 737157829) {
            _x = x[1];
            continue;
          } else {
            return (
              /* Biom */
              737157829
            );
          }
        } else if (variant >= 243398197) {
          return (
            /* Fastq */
            243398197
          );
        } else {
          return (
            /* Fasta */
            243398181
          );
        }
      } else if (variant >= 3553607) {
        return (
          /* Gff */
          3553607
        );
      } else {
        return (
          /* Csv */
          3357606
        );
      }
    }
  }

  ;
}

function base(_x) {
  while (true) {
    var x = _x;

    if (typeof x === "number") {
      return x;
    } else {
      var variant = x[0];

      if (variant !== 374637448) {
        if (variant >= 793449722) {
          _x = x[1];
          continue;
        } else {
          return x;
        }
      } else {
        _x = x[1];
        continue;
      }
    }
  }

  ;
}

function biom_version_to_string_hum(param) {
  if (param !== 648863660) {
    if (param >= 826371656) {
      return "JSON";
    } else {
      return "DDL";
    }
  } else {
    return "Version 2.1";
  }
}

function fastq_to_string_hum(param) {
  if (param !== -91267303) {
    if (param >= -91266633) {
      return "Phred64";
    } else {
      return "Solexa";
    }
  } else {
    return "Phred33";
  }
}

function gff_version_to_string_hum(param) {
  if (param >= 812255803) {
    return "Version 3";
  } else {
    return "Version 2";
  }
}

function to_string_hum$1(param) {
  if (typeof param === "number") {
    if (param >= 3304737) {
      if (param >= 486566049) {
        if (param >= 748691835) {
          if (param !== 758940238) {
            if (param >= 826371656) {
              if (param >= 962246961) {
                return "ASCII";
              } else {
                return "JSON";
              }
            } else if (param >= 804241803) {
              return "HTML";
            } else {
              return "Cram";
            }
          } else {
            return "Date";
          }
        } else if (param !== 487611253) {
          if (param >= 736760884) {
            if (param >= 737456202) {
              return "Boolean";
            } else {
              return "Bash";
            }
          } else if (param >= 642196241) {
            return "Newick";
          } else {
            return "BigBed";
          }
        } else {
          return "BigWig";
        }
      } else if (param >= 4055352) {
        if (param !== 4149247) {
          if (param >= 107576104) {
            if (param >= 365180284) {
              return "Float";
            } else {
              return "Solvuu_runtime_json";
            }
          } else if (param >= 4298873) {
            return "Vcf";
          } else {
            return "Qza";
          }
        } else {
          return "Sam";
        }
      } else if (param >= 3654863) {
        if (param >= 4002953) {
          return "PNG";
        } else {
          return "Integer";
        }
      } else if (param >= 3556729) {
        return "Gtf";
      } else {
        return "Bed";
      }
    } else if (param >= -574959090) {
      if (param >= -77614959) {
        if (param !== -56835286) {
          if (param >= -4561036) {
            if (param >= 3303854) {
              return "Bam";
            } else {
              return "Solvuu_fmt";
            }
          } else if (param >= -50740607) {
            return "Bam (index)";
          } else {
            return "Solvuu_bigdata";
          }
        } else {
          return "Solvuu_dataframe";
        }
      } else if (param >= -293895564) {
        if (param >= -113318020) {
          return "R data";
        } else {
          return "Solvuu_type_json";
        }
      } else if (param >= -522825178) {
        return "Solvuu";
      } else {
        return "Cram (index)";
      }
    } else if (param >= -972455391) {
      if (param !== -953902196) {
        if (param >= -792364981) {
          if (param >= -619744749) {
            return "Solvuu_fmt_json";
          } else {
            return "Bytes";
          }
        } else if (param >= -861261133) {
          return "Solvuu_type";
        } else {
          return "Solvuu_json";
        }
      } else {
        return "Vcf (index)";
      }
    } else if (param >= -976970511) {
      if (param >= -973518485) {
        return "MultiQC";
      } else {
        return "String";
      }
    } else if (param >= -1015245230) {
      return "Solvuu_eval_json";
    } else {
      return "Fasta (index)";
    }
  } else {
    var variant = param[0];

    if (variant >= 243398197) {
      if (variant >= 737157829) {
        if (variant >= 793449722) {
          return to_string_hum$1(param[1]) + ", gzipped";
        } else {
          var match = param[1];

          if (match !== 648863660) {
            if (match >= 826371656) {
              return "Biom (JSON)";
            } else {
              return "Biom (DDL)";
            }
          } else {
            return "Biom (version 2.1)";
          }
        }
      } else if (variant >= 374637448) {
        return to_string_hum$1(param[1]) + ", optional";
      } else {
        var match$1 = param[1];

        if (match$1 !== -91267303) {
          if (match$1 >= -91266633) {
            return "Fastq (Phred64)";
          } else {
            return "Fastq (Solexa)";
          }
        } else {
          return "Fastq (Phred33)";
        }
      }
    } else if (variant !== 3553607) {
      if (variant >= 243398181) {
        return "Fasta";
      } else {
        var csv = param[1];
        var columnsCount = Bolt0_list$Bolt0.length(csv.columns);
        var c = csv.separator;
        var separator = c !== 9 ? c !== 44 ? c !== 59 ? Curry._1(Import$SolvuuRoot0.sprintf(
        /* Format */
        [
        /* Char_literal */
        Block.__(12, [
        /* "'" */
        39,
        /* Char */
        Block.__(0, [
        /* Char_literal */
        Block.__(12, [
        /* "'" */
        39,
        /* End_of_format */
        0])])]), "'%c'"]), c) : "semicolon" : "comma" : "tab";
        return Curry._2(Import$SolvuuRoot0.sprintf(
        /* Format */
        [
        /* String_literal */
        Block.__(11, ["CSV (",
        /* Int */
        Block.__(4, [
        /* Int_d */
        0,
        /* No_padding */
        0,
        /* No_precision */
        0,
        /* String_literal */
        Block.__(11, [" columns, separated by ",
        /* String */
        Block.__(2, [
        /* No_padding */
        0,
        /* Char_literal */
        Block.__(12, [
        /* ")" */
        41,
        /* End_of_format */
        0])])])])]), "CSV (%d columns, separated by %s)"]), columnsCount, separator);
      }
    } else if (param[1] >= 812255803) {
      return "Gff (version 3)";
    } else {
      return "Gff (version 2)";
    }
  }
}

var csv = {
  columns:
  /* [] */
  0,
  separator:
  /* ";" */
  59,
  comment_char: undefined,
  shift_header: false,
  has_header: true,
  quote: undefined
};
var fasta_allow_sharp_comments = Fasta$SolvuuRoot0.Default.allow_sharp_comments;
var fasta_allow_semicolon_comments = Fasta$SolvuuRoot0.Default.allow_semicolon_comments;
var fasta_allow_empty_lines = Fasta$SolvuuRoot0.Default.allow_empty_lines;
var fasta_allow_comments_only_at_top = Fasta$SolvuuRoot0.Default.allow_comments_only_at_top;
var fasta_max_line_length = Fasta$SolvuuRoot0.Default.max_line_length;
var fasta_alphabet = Fasta$SolvuuRoot0.Default.alphabet;
var fasta = {
  allow_sharp_comments: fasta_allow_sharp_comments,
  allow_semicolon_comments: fasta_allow_semicolon_comments,
  allow_empty_lines: fasta_allow_empty_lines,
  allow_comments_only_at_top: fasta_allow_comments_only_at_top,
  max_line_length: fasta_max_line_length,
  alphabet: fasta_alphabet
};

function of_type(x) {
  if (x >= 365180284) {
    if (x !== 374637448) {
      if (x !== 737157829) {
        if (x !== 793449722) {
          return x;
        } else {
          return (
            /* `Gzip */
            [793449722,
            /* Ascii */
            962246961]
          );
        }
      } else {
        return (
          /* `Biom */
          [737157829,
          /* Version2_1 */
          648863660]
        );
      }
    } else {
      return (
        /* `Maybe */
        [374637448,
        /* Int */
        3654863]
      );
    }
  } else if (x !== 3357606) {
    if (x >= 243398181) {
      if (x >= 243398197) {
        return (
          /* `Fastq */
          [243398197,
          /* Phred33 */
          -91267303]
        );
      } else {
        return (
          /* `Fasta */
          [243398181, fasta]
        );
      }
    } else if (x !== 3553607) {
      return x;
    } else {
      return (
        /* `Gff */
        [3553607,
        /* Version2 */
        812255802]
      );
    }
  } else {
    return (
      /* `Csv */
      [3357606, csv]
    );
  }
}

var Default = {
  biom_version:
  /* Version2_1 */
  648863660,
  csv: csv,
  fasta: fasta,
  fastq:
  /* Phred33 */
  -91267303,
  gff_version:
  /* Version2 */
  812255802,
  of_type: of_type
};
var Json = Fmt_bs$SolvuuRoot0;
var json_of_fastq = Fmt_atd$SolvuuRoot0.json_of_fastq;
var json_of_solvuu = Fmt_atd$SolvuuRoot0.json_of_solvuu;
var json_of_solvuu_type = Fmt_atd$SolvuuRoot0.json_of_solvuu_type;
var json_of_solvuu_runtime = Fmt_atd$SolvuuRoot0.json_of_solvuu_runtime;
var json_of_solvuu_eval = Fmt_atd$SolvuuRoot0.json_of_solvuu_eval;
var json_of_solvuu_fmt = Fmt_atd$SolvuuRoot0.json_of_solvuu_fmt;
var json_of_csv_column = Fmt_atd$SolvuuRoot0.json_of_csv_column;
var json_of_csv = Fmt_atd$SolvuuRoot0.json_of_csv;
var json_of_fasta = Fmt_atd$SolvuuRoot0.json_of_fasta;
var json_of_gff_version = Fmt_atd$SolvuuRoot0.json_of_gff_version;
var json_of_biom_version = Fmt_atd$SolvuuRoot0.json_of_biom_version;
var json_of_t = Fmt_atd$SolvuuRoot0.json_of_t;
var fastq_of_json = Fmt_atd$SolvuuRoot0.fastq_of_json;
var solvuu_of_json = Fmt_atd$SolvuuRoot0.solvuu_of_json;
var solvuu_type_of_json = Fmt_atd$SolvuuRoot0.solvuu_type_of_json;
var solvuu_runtime_of_json = Fmt_atd$SolvuuRoot0.solvuu_runtime_of_json;
var solvuu_eval_of_json = Fmt_atd$SolvuuRoot0.solvuu_eval_of_json;
var solvuu_fmt_of_json = Fmt_atd$SolvuuRoot0.solvuu_fmt_of_json;
var csv_column_of_json = Fmt_atd$SolvuuRoot0.csv_column_of_json;
var csv_of_json = Fmt_atd$SolvuuRoot0.csv_of_json;
var fasta_of_json = Fmt_atd$SolvuuRoot0.fasta_of_json;
var gff_version_of_json = Fmt_atd$SolvuuRoot0.gff_version_of_json;
var biom_version_of_json = Fmt_atd$SolvuuRoot0.biom_version_of_json;
var t_of_json = Fmt_atd$SolvuuRoot0.t_of_json;
var Type_all =
/* :: */
[
/* Ascii */
962246961,
/* :: */
[
/* Bam */
3303854,
/* :: */
[
/* Bam_index */
-50740607,
/* :: */
[
/* Bash */
736760884,
/* :: */
[
/* Bed */
3304737,
/* :: */
[
/* Bigbed */
486566049,
/* :: */
[
/* Bigwig */
487611253,
/* :: */
[
/* Biom */
737157829,
/* :: */
[
/* Bool */
737456202,
/* :: */
[
/* Bytes */
-792364981,
/* :: */
[
/* Cram */
748691835,
/* :: */
[
/* Cram_index */
-574959090,
/* :: */
[
/* Csv */
3357606,
/* :: */
[
/* Date */
758940238,
/* :: */
[
/* Fasta */
243398181,
/* :: */
[
/* Fasta_index */
-1040940488,
/* :: */
[
/* Fastq */
243398197,
/* :: */
[
/* Float */
365180284,
/* :: */
[
/* Gff */
3553607,
/* :: */
[
/* Gtf */
3556729,
/* :: */
[
/* Gzip */
793449722,
/* :: */
[
/* Html */
804241803,
/* :: */
[
/* Int */
3654863,
/* :: */
[
/* Json */
826371656,
/* :: */
[
/* Maybe */
374637448,
/* :: */
[
/* MultiQC */
-973518485,
/* :: */
[
/* Newick */
642196241,
/* :: */
[
/* Png */
4002953,
/* :: */
[
/* Qza */
4055352,
/* :: */
[
/* Rdata */
-113318020,
/* :: */
[
/* Sam */
4149247,
/* :: */
[
/* Solvuu */
-522825178,
/* :: */
[
/* Solvuu_bigdata */
-77614959,
/* :: */
[
/* Solvuu_dataframe */
-56835286,
/* :: */
[
/* Solvuu_eval_json */
-1015245230,
/* :: */
[
/* Solvuu_fmt */
-4561036,
/* :: */
[
/* Solvuu_fmt_json */
-619744749,
/* :: */
[
/* Solvuu_json */
-972455391,
/* :: */
[
/* Solvuu_runtime_json */
107576104,
/* :: */
[
/* Solvuu_type */
-861261133,
/* :: */
[
/* Solvuu_type_json */
-293895564,
/* :: */
[
/* String */
-976970511,
/* :: */
[
/* Vcf */
4298873,
/* :: */
[
/* Vcf_index */
-953902196,
/* [] */
0]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]];
var Type = {
  Json: Fmt_type_bs$SolvuuRoot0,
  json_of_t: Fmt_type_atd$SolvuuRoot0.json_of_t,
  json_of_attribute: Fmt_type_atd$SolvuuRoot0.json_of_attribute,
  json_of_attributes: Fmt_type_atd$SolvuuRoot0.json_of_attributes,
  json_of_cst: Fmt_type_atd$SolvuuRoot0.json_of_cst,
  t_of_json: Fmt_type_atd$SolvuuRoot0.t_of_json,
  attribute_of_json: Fmt_type_atd$SolvuuRoot0.attribute_of_json,
  attributes_of_json: Fmt_type_atd$SolvuuRoot0.attributes_of_json,
  cst_of_json: Fmt_type_atd$SolvuuRoot0.cst_of_json,
  to_string_hum: to_string_hum,
  all: Type_all
};
var biom_version_all =
/* :: */
[
/* Version2_1 */
648863660,
/* :: */
[
/* Json */
826371656,
/* :: */
[
/* Ddl */
3403980,
/* [] */
0]]];
var fastq_all =
/* :: */
[
/* Phred33 */
-91267303,
/* :: */
[
/* Phred64 */
-91266633,
/* :: */
[
/* Solexa */
-523669922,
/* [] */
0]]];
var gff_version_all =
/* :: */
[
/* Version2 */
812255802,
/* :: */
[
/* Version3 */
812255803,
/* [] */
0]];
export { Json, json_of_fastq, json_of_solvuu, json_of_solvuu_type, json_of_solvuu_runtime, json_of_solvuu_eval, json_of_solvuu_fmt, json_of_csv_column, json_of_csv, json_of_fasta, json_of_gff_version, json_of_biom_version, json_of_t, fastq_of_json, solvuu_of_json, solvuu_type_of_json, solvuu_runtime_of_json, solvuu_eval_of_json, solvuu_fmt_of_json, csv_column_of_json, csv_of_json, fasta_of_json, gff_version_of_json, biom_version_of_json, t_of_json, Type, to_string_hum$1 as to_string_hum, type_of, base, biom_version_to_string_hum, biom_version_all, fastq_to_string_hum, fastq_all, gff_version_to_string_hum, gff_version_all, Default };
/* Fmt_bs-SolvuuRoot0 Not a pure module */